// removed by extract-text-webpack-plugin
module.exports = {"button":"_8VilQgwTFaL6HGfUmRPJ2","raised":"_1CNoRaRghoETQDRWqK9ny9","flat":"_2dFf8k0C5dn21lY8EP-8Ju","floating":"_2F6gFujNzbjDe9wYp5g7I-","toggle":"_3I1MuooGYcBCiMQ1EMrWdL","rippleWrapper":"_1y--6r998qE8Kml-E8qAyB","icon":"_3Me_E-BRoq5btMFBcVYVvN","mini":"_1AvL1WGqQfwPPCZmopqRrz","neutral":"_3ARnntVTfwIXjdLJ_9KIBJ","inverse":"J-KFHrwGjUkCB9M_qxcPq","primary":"_1P-JxjyAyTtOT0IUO5cFxk","accent":"_27fA0vbXZeyskWFNdZGGjx"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/button/theme.scss
// module id = 560
// module chunks = 0